import { callAuthToken } from '..'
import { getBrand, getBrandGroup, getPurposeId } from '../../core/pure/Env'
import { getAuth0Feature } from '../../core/pure/Window'
import { api, apiPath } from './util'

type patchAccountConsentBody = {
  isAccepted: boolean
  version: string
}

export const patchAccountConsent = async (accountId: string, body: patchAccountConsentBody): Promise<string> => {
  const isAuth0Enabled = getAuth0Feature()

  const token = await callAuthToken()

  return await fetch(
    `${api}${apiPath}${isAuth0Enabled ? getBrandGroup() : getBrand()}/account/${accountId}/consent/${getPurposeId()}`,
    {
      method: 'PATCH',
      headers: {
        'content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    },
  ).then((res) => {
    if (res.ok) return res.json()
    throw new Error(res.statusText)
  })
}
